/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { UpdateService } from './update.service';
import * as firebase from 'firebase/app';
import 'firebase/messaging';
import { environment } from '../environments/environment';
import { SwUpdate, SwPush } from '@angular/service-worker';

@Component({
  selector: 'ngx-app',
  template: `
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {
  displayToken: string;
  constructor(
    private analytics: AnalyticsService,
    private update: UpdateService,

  ) {
    // this.msg.getPermission();
    // this.msg.monitorRefresh();
    // this.msg.receiveMessages();
    // this.msg.initialize();

  }
  ngOnInit(): void {
    this.analytics.trackPageViews();
  }
}
